// extracted by mini-css-extract-plugin
export default {"fallback":"hKybRl_gmIEEsQt_JBHo","title":"WPpUB5gNTzaSFegzfAdS","description":"vMb2Ru4pxoKoEfGoBGNo"};